export const SEAT_SYMBOL_ID = "plane-seat-shape";

export default function SeatSymbolDefs() {
  return (
    <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden focusable="false">
      <defs>
        <symbol id={SEAT_SYMBOL_ID} viewBox="0 0 52 52">
          <path
            d="M5 11C5 4.92487 9.92487 0 16 0H36C42.0751 0 47 4.92487 47 11V42C47 45.3137 44.3137 48 41 48H11C7.68629 48 5 45.3137 5 42V11Z"
            fillOpacity="0.35"
          />
          <rect y="21" width="6" height="26" rx="3" />
          <rect x="46" y="21" width="6" height="26" rx="3" />
          <rect x="16.5" y="40" width="19" height="4" rx="2" />
        </symbol>
      </defs>
    </svg>
  );
}
